import { jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { useResourceDocumentDataContextSafe } from '../../../context/resourceDataContext.js';
import { useQueryDocumentResourceFileContent } from '../../../../queries/useQueryDocumentResourceFileContent.js';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { Flex } from '@fabric-app/ui/components/Flex';
import { CodeRender } from '../../../../../code/components/CodeRender.js';

const ResourceCode = () => {
  const { resource } = useResourceDocumentDataContextSafe();
  const { data: fileContent } = useQueryDocumentResourceFileContent(resource);
  const [scrollRoot, setScrollRoot] = useState(null);
  const code = useMemo(() => {
    if (!fileContent) {
      return "";
    }
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(fileContent);
  }, [
    fileContent
  ]);
  return /* @__PURE__ */ jsx(ScrollArea.Default, {
    orientation: "vertical",
    asFlex: true,
    grow: true,
    expandVertically: true,
    viewportRef: setScrollRoot,
    "data-pan-id-ignore-resource-drag-resize": "xy",
    children: /* @__PURE__ */ jsx(Flex, {
      style: {
        padding: "2rem",
        paddingBottom: "100px"
      },
      minHeight: "100%",
      minWidth: "100%",
      children: /* @__PURE__ */ jsx(CodeRender, {
        mimeType: resource.mimeType ?? void 0,
        code,
        overflow: "hidden",
        scrollRoot: scrollRoot ?? void 0
      })
    })
  });
};

export { ResourceCode };
//# sourceMappingURL=ResourceCode.js.map
